import { IChangeLogHistoryGridRow } from '@/Interfaces/ChangeLogHistory.interface';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

const SummaryCell = ({ row }: GridRenderCellParams<IChangeLogHistoryGridRow>) => (
  <span
    title={row.summary}
    style={{
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      whiteSpace: 'normal',
      lineHeight: 1.3,
      wordBreak: 'break-word',
    }}
  >
    {row.summary}
  </span>
);

export default SummaryCell;
